import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import MaintenancePage from "./components/MaintenancePage";
import cultprjct from "./icons/Cult.png";
import ticketsIcon from "./icons/qpcore.png";
import igIcon from "./icons/qpcore.png";
import tgIcon from "./icons/qpcore.png";
import charityIcon from "./icons/qpcore.png";
import backIcon from './icons/back_icn.png';
import bgMobile from "./bg/bg-mobile-opt.mp4";
import bgLandscape from "./bg/bg-landscape-opt.mp4";
import axios from 'axios';

const TermsConditionsContent = () => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

return (
  <div className="legal-content-container">
    <div className="legal-content" ref={contentRef}>
      <h1>Умови та положення</h1>
      <p><strong>Дата набрання чинності:</strong> 17 квітня 2026 року</p>

      <h2>Вступ</h2>
      <p>
        Ласкаво просимо до Cult Project. Користуючись цією сторінкою, ви погоджуєтеся з цими Умовами та положеннями. Будь ласка, уважно ознайомтеся з ними перед використанням сторінки та переходом за розміщеними посиланнями.
      </p>
      <p>
        Організаційна сторона проєкту представлена <strong>Діаною Максименко (Cult Project)</strong>. Технічну реалізацію сторінки забезпечує <strong>Олександр Трішкін (Quality Performance Core)</strong>.
      </p>

      <h2>Призначення сторінки</h2>
      <p>
        Ця сторінка створена як інформаційний і навігаційний простір для переходу до пов’язаних ресурсів проєкту Cult Project. На сторінці можуть бути розміщені посилання на квитки, Instagram, Telegram та благодійний збір.
      </p>
      <p>
        Зокрема, сторінка може містити переходи на <strong>cult.qpcore.com</strong>, <strong>Instagram @cultprjct</strong>, <strong>Telegram t.me/cult_project_team</strong> та <strong>send.monobank.ua/jar/3jKhSgT5d6</strong>.
      </p>

      <h2>Використання сторінки</h2>
      <p>
        Ви погоджуєтеся використовувати сторінку виключно законним способом, без спроб порушити її роботу, отримати несанкціонований доступ до сервера, змінити вміст сторінки або використати її для шахрайства, спаму чи іншої забороненої діяльності.
      </p>
      <p>
        Забороняється використовувати автоматизовані засоби, скрипти чи інші інструменти, які можуть створювати надмірне навантаження на сервіс або втручатися у його нормальну роботу.
      </p>

      <h2>Сторонні сервіси та переходи</h2>
      <p>
        При переході за зовнішніми посиланнями ви залишаєте межі цієї сторінки та переходите до сторонніх платформ або сервісів. Ми не несемо відповідальності за їхній контент, доступність, політики, правила оплати, збору даних або інші умови використання.
      </p>
      <p>
        Будь-які дії, які ви виконуєте після переходу на сторонній ресурс, регулюються умовами та політиками відповідного сервісу.
      </p>

      <h2>Квитки та сторонні платформи</h2>
      <p>
        Якщо ви переходите на сторінку квитків через <strong>cult.qpcore.com</strong>, подальші умови придбання, оплати, доступу до подій, повернень або обмежень визначаються окремими правилами відповідного сервісу або сторінки продажу.
      </p>

      <h2>Благодійні внески</h2>
      <p>
        Якщо ви переходите за посиланням на благодійний збір через <strong>send.monobank.ua/jar/3jKhSgT5d6</strong>, усі питання, пов’язані з переказами, оплатою, обробкою транзакцій та політиками платіжної сторони, регулюються умовами відповідного платіжного сервісу.
      </p>

      <h2>Інтелектуальна власність</h2>
      <p>
        Назва Cult Project, структура сторінки, текстові матеріали, візуальні елементи, дизайн, а також інші матеріали, розміщені на цій сторінці, належать відповідним правовласникам і охороняються законодавством про інтелектуальну власність.
      </p>
      <p>
        Забороняється копіювати, відтворювати, змінювати або поширювати вміст цієї сторінки без попереднього дозволу правовласника, окрім випадків, прямо дозволених законом.
      </p>

      <h2>Відмова від гарантій</h2>
      <p>
        Сторінка надається за принципом «як є». Ми не гарантуємо безперервну доступність, повну відсутність технічних помилок або постійну роботу всіх зовнішніх посилань і сторонніх сервісів.
      </p>

      <h2>Обмеження відповідальності</h2>
      <p>
        Cult Project та Quality Performance Core не несуть відповідальності за будь-які непрямі, випадкові, спеціальні або побічні збитки, що виникають у зв’язку з використанням цієї сторінки, неможливістю її використання або переходом на сторонні ресурси.
      </p>

      <h2>Припинення доступу</h2>
      <p>
        Ми залишаємо за собою право обмежити або припинити доступ до цієї сторінки без попередження у разі порушення цих Умов, спроб зловживання сервісом або дій, що загрожують безпеці ресурсу.
      </p>

      <h2>Застосовне право та юрисдикція</h2>
      <p>
        Ці Умови регулюються законодавством України. Усі спори, що виникають у зв’язку з використанням цієї сторінки, підлягають розгляду відповідно до застосовного законодавства України.
      </p>

      <h2>Зміни до Умов</h2>
      <p>
        Ми можемо періодично оновлювати ці Умови та положення. Оновлена версія публікується на цій сторінці та набирає чинності з моменту публікації.
      </p>

      <h2>Контакти</h2>
      <p>
        З організаційних питань ви можете звертатися до Cult Project через <a href="mailto:cult@qpcore.com">cult@qpcore.com</a>.
      </p>
      <p>
        З технічних питань щодо платформи ви можете звертатися до розробника: <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
    </div>
  </div>
);

};

const PrivacyPolicyContent = () => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

return (
  <div className="legal-content-container">
    <div className="legal-content" ref={contentRef}>
      <h1>Політика конфіденційності</h1>
      <p><strong>Дата набрання чинності:</strong> 17 квітня 2026 року</p>

      <h2>Вступ</h2>
      <p>
        У Cult Project ми поважаємо вашу приватність і збираємо лише мінімально необхідну технічну інформацію для коректної роботи цієї сторінки. Ця сторінка призначена для розміщення посилань на квитки, Instagram, Telegram та благодійний збір.
      </p>
      <p>
        Організаційна сторона проєкту представлена <strong>Діаною Максименко (Cult Project)</strong>. Технічну розробку та підтримку платформи здійснює <strong>Олександр Трішкін (Quality Performance Core)</strong>.
      </p>

      <h2>Яку інформацію ми можемо обробляти</h2>
      <p>
        Ми не просимо вас створювати акаунт, не збираємо ваше ім’я, email або номер телефону через цю сторінку. Під час використання сторінки можуть оброблятися лише базові технічні дані, необхідні для безпеки, стабільності та базового вимірювання переходів.
      </p>
      <p>
        До таких даних можуть належати технічні журнали сервера, IP-адреса, тип браузера, операційна система, часові мітки запитів та інформація про натискання на кнопки або посилання.
      </p>

      <h2>Посилання на сторонні сервіси</h2>
      <p>
        На цій сторінці розміщені посилання на сторонні сервіси та ресурси, а саме: <strong>cult.qpcore.com</strong> для переходу до квитків, <strong>Instagram @cultprjct</strong>, <strong>Telegram t.me/cult_project_team</strong> та благодійний збір <strong>send.monobank.ua/jar/3jKhSgT5d6</strong>.
      </p>
      <p>
        Після переходу за такими посиланнями подальша обробка даних регулюється політиками конфіденційності відповідних сторонніх сервісів. Ми не контролюємо їхню внутрішню політику обробки даних.
      </p>

      <h2>Аналітика та технічне вимірювання</h2>
      <p>
        Ми можемо використовувати лише мінімальне серверне вимірювання натискань на посилання та кнопки для розуміння активності сторінки, перевірки працездатності та захисту від зловживань.
      </p>
      <p>
        На цій сторінці не обов’язково використовуються клієнтські рекламні пікселі, а якщо певні технічні події фіксуються, вони застосовуються у мінімальному обсязі та без створення профілю користувача для рекламних цілей з нашого боку.
      </p>

      <h2>Cookies</h2>
      <p>
        Ця сторінка не використовує власні маркетингові cookies для персоналізованої реклами. Водночас сторонні сервіси, на які ви переходите, можуть використовувати власні cookies або інші технічні засоби згідно зі своїми правилами.
      </p>

      <h2>Як ми використовуємо інформацію</h2>
      <p>
        Технічні дані можуть використовуватися виключно для забезпечення стабільної роботи сторінки, аналізу базової взаємодії з посиланнями, покращення доступності сервісу та підтримання безпеки серверної інфраструктури.
      </p>
      <p>
        Ми не продаємо, не передаємо в оренду та не обмінюємо персональні дані користувачів третім особам.
      </p>

      <h2>Зберігання даних</h2>
      <p>
        Технічні журнали та події взаємодії можуть зберігатися протягом обмеженого часу, необхідного для безпеки, діагностики та агрегованої статистики, після чого видаляються або знеособлюються.
      </p>

      <h2>Безпека даних</h2>
      <p>
        Ми застосовуємо розумні технічні та організаційні заходи для захисту серверної інфраструктури та мінімізації ризику несанкціонованого доступу.
      </p>

      <h2>Права користувача</h2>
      <p>
        Якщо до вас застосовуються норми законодавства про захист персональних даних, ви можете звернутися із запитом щодо інформації про обробку даних, їх уточнення або видалення в межах, у яких це технічно та юридично застосовно.
      </p>

      <h2>Конфіденційність дітей</h2>
      <p>
        Ця сторінка не призначена спеціально для дітей молодше 13 років, і ми свідомо не збираємо персональні дані дітей.
      </p>

      <h2>Зміни до цієї Політики</h2>
      <p>
        Ми можемо періодично оновлювати цю Політику конфіденційності. Актуальна версія публікується на цій сторінці та набирає чинності з дати публікації.
      </p>

      <h2>Контакти</h2>
      <p>
        З організаційних питань ви можете звертатися до Cult Project через <a href="mailto:cult@qpcore.com">cult@qpcore.com</a>.
      </p>
      <p>
        З технічних питань щодо платформи ви можете звертатися до розробника: <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
    </div>
  </div>
);

}

function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const isMaintenanceMode = false;
  const [isIpAllowed, setIsIpAllowed] = useState(false);

  useEffect(() => {
    const checkIpRoute = async () => {
      try {
        const response = await axios.get("/api/ip/check-ip");
        if (response.data && response.data.allowed === true) {
          setIsIpAllowed(true);
        } else {
          setIsIpAllowed(false);
        }
      } catch (error) {
        console.error("Error checking IP on server:", error);
        setIsIpAllowed(false);
      }
    };

    checkIpRoute();
  }, []);

  const isMaintenanceActive = isMaintenanceMode && !isIpAllowed;

  const handleLinkClick = (event, eventName, url = null) => {
  event.preventDefault();

  const payload = JSON.stringify({ eventName });

  const send = () => {
    if (navigator.sendBeacon) {
      try {
        const blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon('/api/track-event', blob);
      } catch {}
    } else {
      fetch('/api/track-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  };

  if (url) {
    send();
    window.location.assign(url);
  } else {
    send();
  }
};

  const steps = [
    {
      id: 'welcome',
      title: "Вітаємо на платформі",
      subtitle: "Cult Project",
      description: "Корисні посилання",
      content: (
        <div className="button-container">
	  <a
            href="https://cultprjct.qpcore.com/go/tickets"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Tickets', 'https://cultprjct.qpcore.com/go/tickets')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={ticketsIcon} alt="Tickets" className="button-icon" />
              </div>
              <span className="button-text">Квитки</span>
            </div>
          </a>
	  <a
            href="https://cultprjct.qpcore.com/go/instagram"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Instagram', 'https://cultprjct.qpcore.com/go/instagram')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={igIcon} alt="Instagram" className="button-icon" />
              </div>
              <span className="button-text">Instagram</span>
            </div>
          </a>
	  <a
            href="https://cultprjct.qpcore.com/go/telegram"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Telegram', 'https://cultprjct.qpcore.com/go/telegram')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={tgIcon} alt="Telegram" className="button-icon" />
              </div>
              <span className="button-text">Telegram</span>
            </div>
          </a>
	  <a
            href="https://cultprjct.qpcore.com/go/charity"
            className="button"
            onClick={(e) => handleLinkClick(e, 'Charity', 'https://cultprjct.qpcore.com/go/charity')}
          >
            <div className="button-content">
              <div className="button-icon-container">
                <img src={charityIcon} alt="Charity" className="button-icon" />
              </div>
              <span className="button-text">Благодійність</span>
            </div>
          </a>
        </div>
      )
    },
    {
      id: 'privacy-policy',
      title: "",
      subtitle: "",
      description: "",
      content: <PrivacyPolicyContent />
    },
    {
      id: 'terms-conditions',
      title: "",
      subtitle: "",
      description: "",
      content: <TermsConditionsContent />
    }	  
  ];

  const handleFooterLinkClick = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  const handleBackClick = () => {
    if (currentStep !== 0) {
      setCurrentStep(0);
    }
  };

  const renderSteps = () => {
    const step = steps[currentStep];

    return (
      <div
        key={currentStep}
        className={`content visible`}
        id={`step-${currentStep}`}
      >
        {currentStep === 0 && (
          <div className="coin-container">
            <img src={cultprjct} alt="qp Core" className="coin" />
          </div>
        )}
        {step.title && <h1 className="slide-down">{step.title}</h1>}
        {step.subtitle && <h2 className="slide-down">{step.subtitle}</h2>}
        {step.description && <p className="slide-up">{step.description}</p>}
        {step.content}
      </div>
    );
  };

  return isMaintenanceActive ? (
    <MaintenancePage/>
  ):(
   <>

    <video
    className="bg-video mobile-bg"
    src={bgMobile}
    autoPlay
    loop
    muted
    playsInline
  />

  <video
    className="bg-video landscape-bg"
    src={bgLandscape}
    autoPlay
    loop
    muted
    playsInline
  />	

    <div className="App">
      <header className="App-header">

    {currentStep === 0 && (
	  <div className="marquee">
	    <span><em>Next ???</em></span>
	    <span aria-hidden="true"><em>Відчуй атмосферу Cult Project</em></span>
	  </div>
	)}

        {renderSteps()}
        {currentStep !== 0 && (
          <img
            src={backIcon}
            alt="Back"
            className="back-icon visible"
            onClick={handleBackClick}
          />
        )}
      </header>
      <footer className="footer">
        <div className="footer-content slide-up">
          <button
            className="footer-link"
            onClick={() => handleFooterLinkClick(1)}
          >
            Політика
          </button>
          <span className="footer-divider">|</span>
          <button
            className="footer-link"
            onClick={() => handleFooterLinkClick(2)}
          >
            Умови
          </button>
          <span className="footer-divider">|</span>
          <span className="footer-copy">© Cult Project 2026</span>
        </div>
      </footer>
    </div>
   </>
  );
}

export default App;

